





import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GNoDataSpan',
  computed: {},
  methods: {},
})
export default class GNoDataSpan extends Vue {
  mounted() {}
}
